import { h, Component } from 'preact';
// import Store from 'store/store';
// import * as actions from 'store/actions';
// import s from 'components/pages/showtimes/filterOption.sss';
import pure from 'utils/pure';

export default @pure class FilterOption extends Component {

	render({ option, display, selected }) {
		return (
			<option value={option.id}>{display}</option>
		);
	}
}
